export default "__VITE_ASSET__DIsDY1gX__"